module.exports = __webpack_public_path__ + "img/id-lqtafsir-2.a15f921b.webp";